import { createAction, Dispatch } from '@reduxjs/toolkit';
import { BearerboxModel } from '../../models/bearerboxModel';
import { AppError } from '../../types/appError';
import { AppDispatch, RootState } from '../store';
import BearerboxApi from '../../api/bearerboxApi';
import { selectBearerboxByServerId } from './bearerboxSelector';
import { addMinutes, isExpired } from '../../utils/datetimeUtils';

const DEFAULT_BEARERBOX_STATUS_EXP_PERIOD_IN_MINUTES = 5;

const getBearerboxStatusExpirationPeriodInMinutesOrDefault = (): number => (
  process.env.REACT_APP_BEARERBOX_STATUS_EXP_PERIOD_IN_MINUTES
    ? parseInt(process.env.REACT_APP_BEARERBOX_STATUS_EXP_PERIOD_IN_MINUTES, 10)
    : DEFAULT_BEARERBOX_STATUS_EXP_PERIOD_IN_MINUTES
);

const isOutdatedBearerboxStatus = (bearerbox: BearerboxModel): boolean => {
  const expirationPeriodInMinutes = getBearerboxStatusExpirationPeriodInMinutesOrDefault();
  const outdatedTime = addMinutes(bearerbox.fetchedAt, expirationPeriodInMinutes);

  return isExpired(outdatedTime);
};

export const bearerboxFetchRequestAction = createAction<{ serverId: string }>('bearerbox/fetchRequest');
export const bearerboxFetchSuccessAction = createAction<BearerboxModel>('bearerbox/fetchSuccess');
export const bearerboxFetchFailureAction = createAction<{ serverId: string, error: AppError }>('bearerbox/fetchFailure');

export const fetchBearerboxIfOutdated = (serverId: string) => (
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const bearerbox = selectBearerboxByServerId(getState(), serverId);

    if (!bearerbox || isOutdatedBearerboxStatus(bearerbox)) {
      dispatch(fetchBearerboxByServerId(serverId));
    }
  }
);

export const fetchBearerboxByServerId = (serverId: string) => async (dispatch: Dispatch) => {
  dispatch(bearerboxFetchRequestAction({ serverId }));
  try {
    const bearerboxModel = await BearerboxApi.fetchBearerbox(serverId);
    dispatch(bearerboxFetchSuccessAction(bearerboxModel));
  } catch (error) {
    dispatch(bearerboxFetchFailureAction({ serverId, error: error as AppError }));
  }
};
